export default "__VITE_ASSET__BJSfNG1r__"